import { useEffect, useState } from 'react';
import { decodeContact, maskFor } from '@/lib/contactProtect';

type Props = {
  /** contactProtect.CONTACT içindeki kodlanmış değer. */
  encoded: string;
  /** tel: bağlantısı için boşluksuz kodlanmış değer. Yalnızca telefonda. */
  encodedRaw?: string;
  className?: string;
  /** Metinden önce gösterilecek ikon vb. */
  children?: React.ReactNode;
};

/**
 * E-posta adresini yalnızca tarayıcıda çözüp mailto bağlantısı olarak basar.
 * Sunulan HTML ve JS bundle'ında düz adres bulunmaz.
 */
export function ProtectedEmail({ encoded, className, children }: Props) {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(decodeContact(encoded));
  }, [encoded]);

  if (!value) {
    return (
      <span className={className}>
        {children}
        {maskFor('email')}
      </span>
    );
  }

  return (
    <a href={`mailto:${value}`} className={className}>
      {children}
      {value}
    </a>
  );
}

/**
 * Telefon numarasını yalnızca tarayıcıda çözüp tel bağlantısı olarak basar.
 * Görünen metin okunaklı biçimi, bağlantı boşluksuz biçimi kullanır.
 */
export function ProtectedPhone({ encoded, encodedRaw, className, children }: Props) {
  const [value, setValue] = useState('');
  const [raw, setRaw] = useState('');

  useEffect(() => {
    setValue(decodeContact(encoded));
    setRaw(decodeContact(encodedRaw ?? encoded).replace(/\s/g, ''));
  }, [encoded, encodedRaw]);

  if (!value) {
    return (
      <span className={className}>
        {children}
        {maskFor('phone')}
      </span>
    );
  }

  return (
    <a href={`tel:${raw}`} className={className}>
      {children}
      {value}
    </a>
  );
}
